import { tv } from 'tailwind-variants'

export const buttonStyles = tv({
	base: 'group flex items-center w-fit justify-center web:ring-offset-background web:transition-colors web:focus-visible:outline-none web:focus-visible:ring-2 web:focus-visible:ring-ring web:focus-visible:ring-offset-2 rounded-full',
	variants: {
		variant: {
			primary: 'bg-palette_3',
			secondary: 'bg-palette_1',
			tertiary: 'bg-palette_2',
			ghost: 'bg-transparent border-2 border-palette_3',
			ghostBorderless: 'bg-transparent',
		},
		size: {
			default: 'h-10 px-5 py-2 native:h-11',
			sm: 'h-8 px-5',
			xs: 'h-6 px-5',
			lg: 'px-6 web:h-[50px] native:h-12',
		},
		disabled: {
			true: 'opacity-50 web:pointer-events-none',
		},
		withArrow: {
			true: 'justify-between flex-row gap-8 w-auto',
		},
	},
	defaultVariants: {
		variant: 'primary',
		size: 'default',
		disabled: false,
		withArrow: false,
	},
})

export const buttonTextStyles = tv({
	base: 'web:whitespace-nowrap text-sm native:text-base font-apercu-bold',
	variants: {
		variant: {
			primary: 'text-white',
			secondary: 'text-palette_3',
			tertiary: 'text-palette_3',
			ghost: 'text-palette_3',
			ghostBorderless: 'text-palette_3',
		},
		size: {
			default: 'text-base',
			xs: 'text-xs',
			sm: 'text-sm',
			lg: 'text-xl',
		},
		disabled: {
			true: 'opacity-50 web:pointer-events-none',
		},
		spacing: {
			normal: 'tracking-normal',
			wide: 'tracking-[.15em]',
		},
		isLoading: {
			true: 'invisible',
		},
	},
	defaultVariants: {
		variant: 'primary',
		size: 'default',
		spacing: 'normal',
		disabled: false,
		isLoading: false,
	},
})
